



















import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class ProductCoverDialog extends Vue {
  @Prop() private info!: object;

  public data() {
    return {};
  }
  public onCopy() {
    this.$message({
      message: "复制成功",
      type: "success",
    });
  }
  public onError(e: any) {
    this.$message.error("复制失败" + e);
  }
}
